import { IonItemDivider } from '@ionic/react';
import { ComponentProps, PropsWithChildren } from 'react';

import styles from '@/components/Divider/Divider.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

interface DividerProps extends ComponentProps<typeof IonItemDivider> {
  direction?: 'horizontal' | 'vertical';
}

export const Divider = ({ direction = 'horizontal', children, ...props }: PropsWithChildren<DividerProps>) => (
  <IonItemDivider className={mergeClassNames(styles.divider, styles[direction])}>{children}</IonItemDivider>
);
